import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-form',{on:{"submit":_vm.insertSepticData,"close":function($event){return _vm.$emit('close')}},scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('span')]},proxy:true},{key:"button",fn:function(){return [_vm._v("Save "),_c(VIcon,[_vm._v("mdi-content-save")])]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }